// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mKpd","left":"styles_left__3GkWg"};